<template>
  <div>
    <v-text-field
      class="month-input"
      v-model="formatedValue"
      :label="placeholder"
      append-icon="mdi-calendar"
      :readonly="readOnly"
      v-bind="settings"
      outlined
      dense
      :class="error ? 'show-errors' : 'hide-error'"
      :error-messages="error ? 'Por favor, preencha este campo corretamente.' : ''"
      :disabled="disabled"
      @click="openMonthPicker"
      @click:append="openMonthPicker"
    />
    <input
      ref="monthInput"
      type="month"
      :name="name"
      v-model="monthValue"
      @change="updateValue"
      :disabled="disabled || readOnly"
      class="month-input-hidden"
      @click="clearValue"
    />
  </div>
</template>

<script>
export default {
  name: "SGPFormMesComponent",

  props: {
    placeholder: {
      type: String,
      required: false,
      default: "Mês/Ano"
    },
    
    name: {
      type: String,
      required: true,
    },

    parse: {
      type: Boolean,
      required: false,
      default: true,
    },

    value: {
      type: [String, Number],
      required: true,
      default: ''
    },

    readOnly: {
      type: Boolean,
      required: false,
      default: false
    },

    disabled: {
      type: Boolean,
      required: false,
      default: false
    },

    error: {
      type: [Boolean, String],
      required: false,
      default: false
    }
  },

  data() {
    return {
      monthValue: this.value || ''
    }
  },

  computed: {
    settings() {
      return {
        ...this.$attrs
      }
    },

    formatedValue() {
      if (!this.value) return ''
      if (this.value.match(/^\d{4}-\d{2}$/)) {
        const [year, month] = this.value.split('-')
        return `${month}/${year}`
      }
      return this.value
    }
  },

  watch: {
    value(val) {
      this.monthValue = val || ''
    },

    monthValue(val) {
      if (val) {
        this.$emit('input', val)
        this.$emit('change', val)
      }
    },
  },

  methods: {
    updateValue() {
      const v = this.monthValue || ''
      this.$emit('input', v)
      this.$emit('change', v)
    },

    clearValue() {
      this.monthValue = ''
      this.$emit('input', '')
      this.$emit('change', '')
    },

    openMonthPicker() {
      if (!this.readOnly && !this.disabled && this.$refs.monthInput) {
        if (this.$refs.monthInput.showPicker) {
          this.$refs.monthInput.showPicker()
        } else {
          this.$refs.monthInput.click()
        }
      }
    }
  }
}
</script>

<style scoped>
.hide-error.v-text-field__details {
  display: none !important;
}

.month-input-hidden {
  position: absolute;
  opacity: 0;
  width: 1px;
  height: 1px;
  pointer-events: none;
}

.month-input ::v-deep .v-input__append-inner .v-input__icon {
  height: 17px !important;
}
</style>